
<div class="mb-4" *ngIf="totalRecords">
  <p class="text-sm text-sigecom-dark-gray">
    {{ totalRecords | number }} {{label}}
  </p>
</div>